// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
import StarterKit from '@tiptap/starter-kit';
import { TextStyleKit } from '@tiptap/extension-text-style';
import { TableKit } from '@tiptap/extension-table';
import TextAlign from '@tiptap/extension-text-align';
import type { AnyExtension } from '@tiptap/core';

import { ImagePlaceholderNode } from './editor-image-placeholder';
import { CustomImage } from './editor-image-extension';

import '~/components/document-editor/editor-types';

import { DivNode } from './extensions/div-node';
import { PageBreakNode } from './extensions/page-break-node';
import { SectionNode } from './extensions/section-node';
import { StyleNode } from './extensions/style-node';
import { SvgNode } from './extensions/svg-node';
import { StyleAttributeExtension } from './extensions/style-attribute-extension';
import { SmartHighlightExtension } from './extensions/smart-highlight-extension';
import { FontSize } from '~/components/document-editor/extensions/font-size-mark';

/** Register every TipTap extension used by the HTML document editor. */
export const buildEditorExtensions = (scopeId: string): AnyExtension[] =>
  [
    StarterKit.configure({ link: { openOnClick: false } }),
    TableKit,
    TextStyleKit,
    TextAlign.configure({
      types: ['heading', 'paragraph', 'image']
    }),
    ImagePlaceholderNode,
    DivNode,
    SectionNode,
    PageBreakNode,
    CustomImage,
    StyleNode.configure({
      scopeId
    }),
    SvgNode,
    StyleAttributeExtension,
    SmartHighlightExtension,
    FontSize
  ] as AnyExtension[];
